import React from "react";
import cx from "clsx";
import { Box } from "../../../../../../../../shared/Box/Box";
import styles from "./styles.module.scss";
import { useContext } from "../../../../context";
import { InputQuestion } from "./InputQuestion";
import { InputDescription } from "./InputDescription";
import { Choices } from "./Choices";
import { DragIcon } from "../../../../../../../../shared/DragIcon/DragIcon";
import { useAppTranslation } from "../../../../../../../../i18n/useAppTranslation";

const Block = ({ id, elementId, required, markContent, children }) => {
  const { focusedBlock, blockErrors } = useContext();

  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  const active = focusedBlock.id === id && Boolean(id);

  const focus = () => {
    if (id) {
      focusedBlock.set(id);
    }
  };

  const errors = blockErrors.get(id);
  const hasErrors = errors.length > 0;

  return (
    <Box
      id={id || elementId}
      onClick={focus}
      className={cx(styles.root, {
        [styles.rootError]: blockErrors.has(id || elementId),
        [styles.rootActive]: active,
      })}
    >
      <div className={styles.inner}>
        <div className={styles.left}>
          {!!id && <DragIcon className={styles.draggable} />}
          <div className={cx(styles.mark, { [styles.markActive]: active })}>
            {markContent}
          </div>
        </div>
        <div className={styles.content}>{children}</div>
        {required && <span className={styles.required}>*</span>}
      </div>
      {hasErrors && (
        <div className={styles.errors}>
          {errors.map((msg) => (
            <div key={msg}>{t(`error.${msg}`)}</div>
          ))}
        </div>
      )}
    </Box>
  );
};

Block.Question = InputQuestion;
Block.Description = InputDescription;
Block.Choices = Choices;

export { Block };
